import { render, staticRenderFns } from "./OtpIndex.vue?vue&type=template&id=5765a256&scoped=true&"
import script from "./OtpIndex.vue?vue&type=script&lang=js&"
export * from "./OtpIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5765a256",
  null
  
)

export default component.exports